import { Product } from "~/bff/types/Product";
import { WidgetDocs } from "~/bff/types/WidgetDocs";
import { ClickCollectStatuses } from "~/constants/data-layer";
import { Nullable } from "~/types/general.types";

export const clickAndCollectProductStatusGA = (
  product?: Nullable<Product> | WidgetDocs,
): string => {
  if (product?.clickAndCollectExclusive) {
    return ClickCollectStatuses.clickCollectExclusive;
  }

  if (product?.clickAndCollect) {
    return ClickCollectStatuses.clickCollect;
  } else {
    return ClickCollectStatuses.nonClickCollect;
  }
};
